export enum SpecialUserGroups {
    MARLES = '34',
}

export const USER_GROUP_DISCOUNTS: Record<string, number> = {
    [SpecialUserGroups.MARLES]: 4,
};

export const DEFAULT_DISCOUNT = 2;